'use strict';

import scorllTop from './common/scroll_top.vue'
// import breadCrumb from './common/bread_crumb.vue'
import breadCrumb from './common/breadcrumb.vue'
import pagination from './common/pagination.vue'
import Empty from './common/empty.vue'
// import Header from './header/header2.vue'
import Header from './header/newHeader.vue'
import Footer from './header/footer.vue'
import Login from './login/login.vue'
import Login2 from './login/login2.vue'
import Login3 from './login/login3.vue'




const Coms = {
    scorllTop,
    breadCrumb,
    pagination,
    Empty,
    Header,
    Footer,
    Login,
    Login2,
    Login3
  }

// vue批量引入全局组件
const PageComs = {
  install(Vue) {
    for (let key in Coms) {
      Vue.component(key, Coms[key]);
    }
  }
}

export default PageComs
